import React, { Fragment } from 'react';
import { Card, Col, Row } from 'antd';
import {currencyVND} from '../../../../utils';

export default ({product}) => {

	const InfoRow = ({ label, value }) => (
		<Row style={{ marginBottom: 8 }}>
			<Col span={10} >{label}</Col>
			<Col span={14}>: {value || '---'}</Col>
		</Row>
	);

	return <Fragment>
		<Card title="Giá sản phẩm">
			<Row>
				<Col span={12}>
					<InfoRow label="Giá bán lẻ" value={currencyVND(product.retailPrice)} />
					<InfoRow label="Giá nhập" value={currencyVND(product.importPrice)} />
					{/*<InfoRow label="Tên chính sách giá" value={'---'} />*/}
				</Col>
				<Col span={12}>
					<InfoRow label="Giá bán buôn" value={currencyVND(product.wholesalePrice)}/>
				</Col>
			</Row>
		</Card>
	</Fragment>
}
